// extracted by mini-css-extract-plugin
export default {"orderDetailsGrid":"OrderDetails_orderDetailsGrid__eoI--"};